import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-face-analytics',
  templateUrl: './face-analytics.component.html',
  styleUrls: ['./face-analytics.component.css']
})
export class FaceAnalyticsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
